// Types
import type { LocaleProps } from '@/types/config/locale'

// Configurations
import Config from '@/config'

const LocaleConfig: LocaleProps = {
	default: 'en',
	list: ['en', 'es', 'ar', 'fa'],
	fallbackLng: 'en',
	ns: ['common', 'form', 'links'],
	cookieName: `${Config.shortName.toLocaleLowerCase()}-i18next`
}

export default LocaleConfig
